import { HighwayIcon } from './HighwayIcon';

/**
 * author: Christopher Schreiner
 * id 81E5D79D-2ECD-4040-9B07-3A0C19792348
 * name highway
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/highway.svg
 * tags
 * - Transportation + Road 
 */
export const MotorwayIcon = HighwayIcon;
export default MotorwayIcon